import { render, staticRenderFns } from "./Goodwill.vue?vue&type=template&id=4867e062&scoped=true"
import script from "./Goodwill.vue?vue&type=script&lang=js"
export * from "./Goodwill.vue?vue&type=script&lang=js"
import style0 from "./Goodwill.vue?vue&type=style&index=0&id=4867e062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867e062",
  null
  
)

export default component.exports